import { ReactElement } from 'react';
import { UIText } from '@/ui';
import styles from './existing-companies.module.scss';
import { REGION_BRAND_LOGOS } from '../assets/brands';
import { useRegion } from '../providers/region-provider';
import { useCommonTranslation } from '../hooks';

export function ExistingCompanies(): ReactElement | null {
    const { t } = useCommonTranslation();
    const { resolvedRegion } = useRegion();

    const logos = REGION_BRAND_LOGOS[resolvedRegion];
    if (!logos.length) return null;

    return (
        <div className={styles.container}>
            <UIText variant="h1" textAlign="center" type="link">
                {t('components.existing_companies.title')}
            </UIText>
            <div className={styles.logos}>
                {logos.map((row, rowIndex) => (
                    <div key={rowIndex} className={styles.logoRow}>
                        {row.map((logo) => (
                            <div
                                key={logo.brand}
                                className={styles.logoContainer}
                            >
                                <img
                                    src={logo.src}
                                    alt={t(
                                        'components.existing_companies.logo_alt',
                                        {
                                            brand: logo.brand
                                        }
                                    )}
                                    className={styles.logoImage}
                                />
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
